let bundle_price__container_regular_price = document.querySelector('.product__info-wrapper .bundle_price__container_regular_price');
let bundle_price__container_compare_price = document.querySelector('.product__info-wrapper .bundle_price__container_compare_price');
let bundle_price__container_discount_percentage = document.querySelector('.bundle_price__container_discount_percentage');

window.bundle_money_format=(e)=>{let t=document.querySelector(".custom_bundle_money_format"),a=t?.dataset?.money||"${{amount}}";function n(e,t){return void 0===e?t:e}function r(e,t=2,a=",",n="."){if(isNaN(e)||null==e)return"0";e=(e/100).toFixed(t);let r=e.split("."),o=r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+a),u=r[1]?n+r[1]:"";return o+u}"string"==typeof e&&(e=parseInt(e=e.replace(".",""),10));let o=/\{\{\s*(\w+)\s*\}\}/,u=a.match(o),c="";if(!u)return e;switch(u[1]){case"amount":default:c=r(e,2);break;case"amount_no_decimals":c=r(e,0);break;case"amount_with_comma_separator":c=r(e,2,".",",");break;case"amount_no_decimals_with_comma_separator":c=r(e,0,".",",")}return a.replace(o,c)}


window.get_discount_percentage=(regularPrice, comparePrice)=> {
  if (!regularPrice || !comparePrice || comparePrice <= regularPrice) {
    return '0';
  }
 const discount = ((comparePrice - regularPrice) / comparePrice) * 100;
  return `${Math.round(discount)}`;
}
window.bundle_variant_change=(variant_input)=>{
  let sticky_custom_atc_containor_price = document.querySelector('.sticky_custom_atc_containor .bundle_price__container_regular_price');
  let sticky_custom_atc_containor_discount_precentage = document.querySelector('.sticky_custom_atc_containor .bundle_price__container_discount_percentage');
  let bundle_option_containors = document.querySelectorAll('.bundle-prdicts-variants variant-selects');
  let bundle_total_price = 0;
  let bundle_total_compare_price = 0;
  bundle_option_containors.forEach((bundle_option_containor)=>{
    let bundle_product_inputs = bundle_option_containor.querySelectorAll('.bundle_product_input');
    let is_variant_selected = false;
     bundle_product_inputs.forEach(input_bundle_product => {
          if(input_bundle_product.checked){
            bundle_total_price += parseFloat(input_bundle_product.dataset.bundle_pro_var_price);
            if(input_bundle_product.dataset.bundle_pro_var_compare_price){
             bundle_total_compare_price += parseFloat(input_bundle_product.dataset.bundle_pro_var_compare_price);
            }
            is_variant_selected = true;
          }
    });
    if(!is_variant_selected){
       let first_avai_var_found = false;
       bundle_product_inputs.forEach(input_bundle_product => {
         if(!first_avai_var_found && !input_bundle_product.classList.contains('visually-disabled')){
          bundle_total_price += parseFloat(input_bundle_product.dataset.bundle_pro_var_price);
          if(input_bundle_product.dataset.bundle_pro_var_compare_price){
           bundle_total_compare_price += parseFloat(input_bundle_product.dataset.bundle_pro_var_compare_price);
          }
          first_avai_var_found = true;
         }
       });
    }
  })
  bundle_price__container_regular_price.innerHTML = bundle_money_format(bundle_total_price);
  bundle_price__container_compare_price.innerHTML = bundle_money_format(bundle_total_compare_price);
  if(bundle_total_price>=bundle_total_compare_price){
    bundle_price__container_compare_price.classList.add('hidden');
  }else{
    bundle_price__container_compare_price.classList.remove('hidden');
  }

  sticky_custom_atc_containor_price.innerHTML = bundle_money_format(bundle_total_price);

  bundle_price__container_discount_percentage.innerHTML = get_discount_percentage(bundle_total_price,bundle_total_compare_price);
  if(get_discount_percentage(bundle_total_price,bundle_total_compare_price) == '0'){
    bundle_price__container_discount_percentage.closest('.label_sale').classList.add('hidden');
  }else{
    bundle_price__container_discount_percentage.closest('.label_sale').classList.remove('hidden');
  }
  
  sticky_custom_atc_containor_discount_precentage.innerHTML = get_discount_percentage(bundle_total_price,bundle_total_compare_price);
  if(get_discount_percentage(bundle_total_price,bundle_total_compare_price) == '0'){
    sticky_custom_atc_containor_discount_precentage.closest('.label_sale').classList.add('hidden');
  }else{
    sticky_custom_atc_containor_discount_precentage.closest('.label_sale').classList.remove('hidden');
  }

  if(variant_input.checked){
      variant_input.closest('variant-selects').querySelector('.bundle_error_msg').classList.add('hidden');
      variant_input.closest('variant-selects').querySelector('.bundle_error_msg').classList.remove('show');
  }
}

window.bundle_select_first_avai_var=()=>{
  let sticky_custom_atc_containor_price = document.querySelector('.sticky_custom_atc_containor .bundle_price__container_regular_price');
  let sticky_custom_atc_containor_discount_precentage = document.querySelector('.sticky_custom_atc_containor .bundle_price__container_discount_percentage');
  let bundle_option_containors = document.querySelectorAll('.bundle-prdicts-variants variant-selects');
  let bundle_default_total_price = 0;
  let bundle_default_total_compare_price = 0;
  bundle_option_containors.forEach((bundle_option_containor)=>{
    let bundle_product_inputs = bundle_option_containor.querySelectorAll('.bundle_product_input');
    let first_avai_var_found = false;
     bundle_product_inputs.forEach(input_bundle_product => {
         if(!first_avai_var_found && !input_bundle_product.classList.contains('visually-disabled')){
          bundle_default_total_price += parseFloat(input_bundle_product.dataset.bundle_pro_var_price);
          if(input_bundle_product.dataset.bundle_pro_var_compare_price){
           bundle_default_total_compare_price += parseFloat(input_bundle_product.dataset.bundle_pro_var_compare_price);
          }
          first_avai_var_found = true;
         }
    });
  })
  bundle_price__container_regular_price.innerHTML = bundle_money_format(bundle_default_total_price);
  bundle_price__container_compare_price.innerHTML = bundle_money_format(bundle_default_total_compare_price);
  console.log("bundle_default_total_price",bundle_default_total_price);
  console.log("bundle_default_total_compare_price",bundle_default_total_compare_price);
  if(bundle_default_total_price>=bundle_default_total_compare_price){
    bundle_price__container_compare_price.classList.add('hidden');
  }else{
    bundle_price__container_compare_price.classList.remove('hidden');
  }
  sticky_custom_atc_containor_price.innerHTML = bundle_money_format(bundle_default_total_price);

  bundle_price__container_discount_percentage.innerHTML = get_discount_percentage(bundle_default_total_price,bundle_default_total_compare_price);
  if(get_discount_percentage(bundle_default_total_price,bundle_default_total_compare_price) == '0'){
    bundle_price__container_discount_percentage.closest('.label_sale').classList.add('hidden');
  }else{
    bundle_price__container_discount_percentage.closest('.label_sale').classList.remove('hidden');
  }

  sticky_custom_atc_containor_discount_precentage.innerHTML = get_discount_percentage(bundle_default_total_price,bundle_default_total_compare_price);
  if(get_discount_percentage(bundle_default_total_price,bundle_default_total_compare_price) == '0'){
    sticky_custom_atc_containor_discount_precentage.closest('.label_sale').classList.add('hidden');
  }else{
    sticky_custom_atc_containor_discount_precentage.closest('.label_sale').classList.remove('hidden');
  }
}
bundle_select_first_avai_var();

document.addEventListener("DOMContentLoaded", function () {
 bundle_select_first_avai_var();
})